































import {Component, Prop} from 'vue-property-decorator';
import Vue from 'vue';
import moment from 'moment';

@Component
export default class InvoicesTable extends Vue {
  @Prop()
  unpaidData: any;

  @Prop()
  totalUnpaid: any;

  @Prop()
  sumFormat: any;

  moment=moment;
}
